/*
 * @Author: Lina
 * @Date: 2020-06-29 11:25:59
 * @LastEditors: Lina
 * @LastEditTime: 2020-06-30 13:05:56
 */ 
const host = (window.crgt && window.crgt.isProd) ? 'https://static.ccrgt.com' : 'https://t-static.ccrgt.com';

export default {
  'netCar': {
    'path': `${host}/FE-CARHAILING-H5/#/`
  },
  'netCarOrder': {
    'path': `${host}/FE-CARHAILING-H5/#/`
  },
  'foodOrdering': null,
  'ticket': null,
  'video': null,
  'vipLounge': null,
  'hotel': null,
  'phoneRecharge': null,
  'youzan': null,
  'rentCar': null,
  'redHat': null,
  'shareBus': null
}
